module.exports = __webpack_public_path__ + "img/mazer-2.0cb6aed0.jpg";